module.exports = __webpack_public_path__ + "img/newsInfoEnd.png";